import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import {
  PageSubTitle,
  EmptyState,
  LinkBack,
  Loading
} from 'components/common/Elements/Elements';

import PlatformNetwork from './parts/PlatformNetwork/PlatformNetwork';

import { postRequest } from 'utils/requests';
import classes from './PlatformNetworks.module.scss';

const PlatformNetworks = ({ customerId }) => {
  const [networksData, setNetworksData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    let cancelled = false;
    postRequest('/customer/platform/networks/list', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          const networks = res.body.networks;
          setNetworksData(networks);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  const { t } = useTranslation(['activity']);

  if (loader) {
    return <Loading />;
  }

  if (networksData && networksData.length > 0) {
    return (
      <>
        <div className={classes.header}>
          <PageSubTitle title={t('activity:platform.NETWORKS')} />
          <LinkBack text="Platform" />
        </div>
        <div className={classes.stickyContainer}>
          {networksData.map(network => (
            <PlatformNetwork key={network.networkId} item={network} />
          ))}
        </div>
      </>
    );
  } else {
    return <EmptyState message="connect" />;
  }
};

PlatformNetworks.propTypes = {
  customerId: PropTypes.string
};

export default PlatformNetworks;
